import { SERVICE_WORKER_CONFIG } from "./swServiceWorker.config";

/** Re-export for apps that read SW metadata outside registration. */
export { SERVICE_WORKER_CONFIG } from "./swServiceWorker.config";

/**
 * Registers the production service worker.
 * Skipped in development and test; set REACT_APP_ENABLE_PWA_SW=false to disable.
 */
export function registerSW(): void {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }
  if (process.env.NODE_ENV !== "production") {
    return;
  }
  if (process.env.REACT_APP_ENABLE_PWA_SW === "false") {
    return;
  }

  const { scriptPath, registrationScope, updateViaCache } =
    SERVICE_WORKER_CONFIG;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(scriptPath, {
        scope: registrationScope,
        updateViaCache
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[PWA] Service worker registration failed:", err);
      });
  });
}
